<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Crear Promotor" />

    <CreatePromotor />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue"; 
import CreatePromotor from "@/components/Pages/Admin/Promotors/view.vue";

export default defineComponent({
  name: "CreateCompanyPage",
  components: {
    PageTitle,
    CreatePromotor,
  },
});
</script>
